import { render } from "./DefaultViewBatchContainer.vue?vue&type=template&id=47ab457f&scoped=true"
import script from "./DefaultViewBatchContainer.vue?vue&type=script&lang=js"
export * from "./DefaultViewBatchContainer.vue?vue&type=script&lang=js"

import "./DefaultViewBatchContainer.vue?vue&type=style&index=0&id=47ab457f&lang=css&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ab457f"]])

export default __exports__